var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.69 85.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,7.25c-2.74-4.86-5.84-7.25-9.2-7.25s-6.37,2.39-9.11,7.25c-2.74,4.78-4.78,11.14-6.01,18.92h30.33c-1.24-7.78-3.27-14.15-6.01-18.92h0ZM26.79,53.85H58.89c.35-3.71,.53-7.34,.53-11.05s-.18-7.34-.53-11.05H26.79c-.35,3.71-.53,7.34-.53,11.05s.18,7.34,.53,11.05h0ZM71.45,10.97c-4.78-4.33-10.26-7.43-16.36-9.28,4.07,5.75,6.9,13.97,8.67,24.49h18.66c-2.56-5.84-6.19-10.97-10.97-15.21h0Zm-57.21,0c-4.78,4.24-8.4,9.37-10.97,15.21H21.93c1.59-10.52,4.51-18.75,8.67-24.49-6.1,1.86-11.58,4.95-16.36,9.28h0Zm50.23,20.78c.27,3.8,.44,7.52,.44,11.05s-.18,7.25-.44,11.05h19.63c1.06-3.71,1.59-7.34,1.59-11.05s-.53-7.34-1.59-11.05h-19.63Zm-43.24,0H1.59c-1.06,3.8-1.59,7.52-1.59,11.05s.53,7.25,1.59,11.05H21.22c-.35-3.89-.53-7.6-.53-11.05s.18-7.25,.53-11.05h0Zm12.47,46.6c2.74,4.86,5.84,7.25,9.11,7.25s6.46-2.39,9.2-7.25c2.74-4.78,4.78-11.14,6.01-19.01H27.68c1.24,7.87,3.27,14.24,6.01,19.01h0Zm37.76-3.71c4.78-4.24,8.4-9.37,10.97-15.3h-18.66c-1.68,10.61-4.51,18.84-8.67,24.58,6.1-1.86,11.58-4.95,16.36-9.28h0Zm-57.21,0c4.78,4.33,10.26,7.43,16.36,9.28-4.07-5.75-6.9-13.97-8.67-24.58H3.27c2.56,5.92,6.19,11.05,10.97,15.3h0Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.12f8ced0084253eebaff1b876467cd77.svg";
export { ForwardRef as ReactComponent };